import { DATE_FORMATS, DateUtils } from "shared/dateUtils";
import { notifyError } from "../../../redux/actions/notificacaoActions";
import ConciliacaoManager from "../conciliacaoManager";
import {
  exibirCarregando,
  listarConciliacoesFazenda,
  listarDetalhesCategoria,
} from "./conciliacaoActions";

export const obterConciliacoes =
  (idFazenda, dataInicial, dataFinal, dataInicioConciliacao) =>
  async (dispatch) => {
    dispatch(exibirCarregando(true));
    try {
      const dataInicio = DateUtils.parse(dataInicial).format(
        DATE_FORMATS["YYYY-MM-DD"]
      );
      const dataFim = DateUtils.parse(dataFinal).format(
        DATE_FORMATS["YYYY-MM-DD"]
      );
      const dataInicioConciliacaoFormatada = DateUtils.parse(
        dataInicioConciliacao
      ).format(DATE_FORMATS["YYYY-MM-DD"]);

      const conciliacoesFazenda =
        await ConciliacaoManager.listarConciliacoesFazenda(
          idFazenda,
          dataInicio,
          dataFim,
          dataInicioConciliacaoFormatada
        );
      dispatch(listarConciliacoesFazenda(conciliacoesFazenda.data));
    } catch (error) {
      const mensagemErro = {
        mensagem: "Ocorreu um erro ao obter a lista de conciliações.",
      };
      dispatch(listarConciliacoesFazenda([]));
      dispatch(notifyError(mensagemErro));
    } finally {
      dispatch(exibirCarregando(false));
    }
  };

export const obterDetalhesCategoria =
  (idFazenda, idCategoria, dataInicial, dataFinal) => async (dispatch) => {
    try {
      const operacoes = await ConciliacaoManager.detalhesCategoriaConciliacao(
        idFazenda,
        idCategoria,
        dataInicial,
        dataFinal
      );
      dispatch(listarDetalhesCategoria(operacoes.data));
    } catch (error) {
      const mensagemErro = {
        mensagem: "Ocorreu um erro ao obter a lista de operações",
      };
      dispatch(listarDetalhesCategoria({}));
      dispatch(notifyError(mensagemErro));
    }
  };
